import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import { AddressPropType } from '../../../../prop-types/address';
import style from '../style.module.less';

export const ValidationAddressSelection = ({ address }) => {
  return (
    <div className={style.address}>
      <Text textType={TextType.Paragraph} value={address?.line1} />
      <Text textType={TextType.Paragraph} value={address?.line2 ?? ''} />
      <Text textType={TextType.Paragraph} value={address?.line3 ?? ''} />
      <Text textType={TextType.Paragraph} value={`${address?.city}, ${address?.state} ${address?.postalCode}`} />
      <Text textType={TextType.Paragraph} value={address?.countryCode} />
    </div>
  );
};

ValidationAddressSelection.propTypes = {
  address: AddressPropType.isRequired,
};
